import {
	mapGetters,
	mapActions
} from 'vuex';

import {
	EventBus
} from '@/support/event-bus';

export default {
	name: 'copy-homework',
	props: {
		disabled: {
			type: Boolean,
			default: false
		},
		index: {
			type: Number,
			default: 'false'
		}
	},
	computed: {
		...mapGetters([
			'getHomeworkList'
		])
	},
	methods: {
		...mapActions([
			'copyHomeworkbyClass'
		]),
		copyHomework(index) {

			this.copyHomeworkbyClass({
				index: index,
				themes: this.getHomeworkList
			}).then(() => {
				EventBus.$emit('setAgenda');
			});

		}
	}
};



// WEBPACK FOOTER //
// ./sources/domains/homework/copy/index.js